import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function Footer() {
  const { locale, t } = useI18n();
  const l = (path) => `/${locale}${path === "/" ? "" : path}`;

  const legalRows = [
    ["footer.companyLabel", "footer.company"],
    ["footer.rfcLabel", "footer.rfc"],
    ["footer.folioLabel", "footer.folio"],
    ["footer.licenseLabel", "footer.license"],
    ["footer.jurisdictionLabel", "footer.jurisdiction"],
    ["footer.incorporationLabel", "footer.incorporation"],
  ];

  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-[#dbe4ea] bg-[#0b2f47] text-[#dbe6ef]"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-3 md:px-8">
        <div className="md:col-span-2">
          <h3
            className="text-2xl font-semibold text-white"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
            data-testid="footer-about-title"
          >
            {t("footer.aboutTitle")}
          </h3>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-[#c5d3df]">
            {t("footer.aboutText")}
          </p>
          <div className="mt-6 space-y-2 text-sm text-[#c5d3df]">
            <p>
              <span className="text-white/70">{t("footer.addressLabel")}: </span>
              {t("footer.address")}
            </p>
            <p>
              <span className="text-white/70">{t("footer.phoneLabel")}: </span>
              <a href={`tel:${t("footer.phone").replace(/\s/g, "")}`} className="hover:text-white" data-testid="footer-phone">
                {t("footer.phone")}
              </a>
            </p>
            <p>
              <span className="text-white/70">{t("footer.emailLabel")}: </span>
              <a href={`mailto:${t("footer.email")}`} className="hover:text-white" data-testid="footer-email">
                {t("footer.email")}
              </a>
            </p>
            <p>
              <span className="text-white/70">{t("footer.hoursLabel")}: </span>
              {t("footer.hours")}
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white">
            {t("footer.legalTitle")}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to={l("/privacy-policy")} className="hover:text-white" data-testid="footer-link-privacy">{t("privacy.title")}</Link></li>
            <li><Link to={l("/cookie-policy")} className="hover:text-white" data-testid="footer-link-cookies">{t("cookies.title")}</Link></li>
            <li><Link to={l("/terms")} className="hover:text-white" data-testid="footer-link-terms">{t("terms.title")}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto grid max-w-7xl gap-8 px-5 py-10 md:grid-cols-2 md:px-8">
          <dl className="grid grid-cols-1 gap-2 text-xs text-[#a9bccd] sm:grid-cols-2" data-testid="footer-legal-details">
            {legalRows.map(([lbl, val]) => (
              <div key={lbl} className="flex flex-col">
                <dt className="uppercase tracking-[0.14em] text-[#7a94aa]">{t(lbl)}</dt>
                <dd className="mt-1 text-white/90">{t(val)}</dd>
              </div>
            ))}
          </dl>
          <div className="text-xs leading-relaxed text-[#a9bccd]">
            <p data-testid="footer-disclaimer">{t("footer.disclaimer")}</p>
            <p className="mt-3 text-[#7a94aa]" data-testid="footer-rights">{t("footer.rights")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
